import Banner from "./banner/Banner";
import Search from "./search/Search";
import Articles from "./articles/articles";
import Notifications from "./notifications/notifications";
import CookieBar from "./cookies/bar/CookieBar";
import CookiePage from "./cookies/page/CookiePage";
import Navigator from "./navigator/Navigator.js";
import Shops from "@modules/navigator/Shops/Shops.js";

const Modules = {

    init() {
        CookieBar.init();
        CookiePage.init();
        Banner.init();
		Search.init();
        Articles.init();
        Notifications.init();
        Navigator.init();
        Shops.init();
    },

    resize(){
        Banner.resize();
        Navigator.resize();
    },

    setByUrl(path, search) {
    }
}

export default Modules;